import store from 'store';
import { i18n } from '@/setup/i18n';
import {
  GET_WEBSITE_CONTACT_PAGE_DATA,
  GET_WEBSITE_HOME_PAGE_DATA,
  GET_WEBSITE_PROJECTS_PAGE_DATA,
  GET_WEBSITE_WHAT_WE_DO_PAGE_DATA,
  GET_WEBSITE_OUR_COMPANY_PAGE_DATA,
  GET_CATEGORIES_DATA,
  GET_PROJECTS_SUMMARY_DATA,
  GET_PROJECT_BY_SLUG_DATA,
  GET_PROJECTS_FOR_HOME_DATA,
  GET_REVIEWS_DATA,
  GET_EMPLOYEES_DATA,
  GET_WEBSITE_LEGAL_DATA
} from 'store/actions/website';

// Redirect to the error page
const redirectToErrorPage = (next, resource) => next({ name: 'error', params: { resource } });

export default [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "pages/views/home" */ 'views/Home'),
    meta: { i18nTitleKey: 'home' },
    name: 'home',
    beforeEnter(to, from, next) {
      const locale = i18n().locale;
      Promise.all([
        store.dispatch(`website/${GET_WEBSITE_HOME_PAGE_DATA}`, locale),
        store.dispatch(`website/${GET_CATEGORIES_DATA}`, locale),
        store.dispatch(`website/${GET_PROJECTS_FOR_HOME_DATA}`, locale),
        store.dispatch(`website/${GET_REVIEWS_DATA}`, locale)
      ])
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_WEBSITE_HOME_PAGE_DATA);
        });
    }
  },
  {
    path: '/projects',
    component: () => import(/* webpackChunkName: "pages/views/projects" */ 'views/Projects'),
    meta: { i18nTitleKey: 'projects' },
    name: 'projects',
    beforeEnter(to, from, next) {
      const locale = i18n().locale;
      Promise.all([
        store.dispatch(`website/${GET_WEBSITE_PROJECTS_PAGE_DATA}`, locale),
        store.dispatch(`website/${GET_CATEGORIES_DATA}`, locale),
        store.dispatch(`website/${GET_PROJECTS_SUMMARY_DATA}`, locale)
      ])
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_WEBSITE_PROJECTS_PAGE_DATA);
        });
    }
  },
  {
    path: '/projects/detail/:slug',
    component: () =>
      import(/* webpackChunkName: "pages/views/project-detail" */ 'views/Projects/Detail'),
    name: 'projectDetail',
    beforeEnter(to, from, next) {
      const locale = i18n().locale;
      const { slug } = to.params;
      Promise.all([
        store.dispatch(`website/${GET_WEBSITE_PROJECTS_PAGE_DATA}`, locale),
        store.dispatch(`website/${GET_PROJECT_BY_SLUG_DATA}`, { slug, locale })
      ])
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_PROJECT_BY_SLUG_DATA);
        });
    }
  },
  {
    path: '/contact',
    component: () => import(/* webpackChunkName: "pages/views/contact" */ 'views/Contact'),
    meta: { i18nTitleKey: 'contact' },
    name: 'contact',
    beforeEnter(to, from, next) {
      store
        .dispatch(`website/${GET_WEBSITE_CONTACT_PAGE_DATA}`, i18n().locale)
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_WEBSITE_CONTACT_PAGE_DATA);
        });
    }
  },
  {
    path: '/what-we-do',
    component: () => import(/* webpackChunkName: "pages/views/what-we-do" */ 'views/WhatWeDo'),
    meta: { i18nTitleKey: 'whatWeDo' },
    name: 'what-we-do',
    beforeEnter(to, from, next) {
      const locale = i18n().locale;
      Promise.all([
        store.dispatch(`website/${GET_WEBSITE_WHAT_WE_DO_PAGE_DATA}`, locale),
        store.dispatch(`website/${GET_CATEGORIES_DATA}`, locale)
      ])
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_WEBSITE_WHAT_WE_DO_PAGE_DATA);
        });
    }
  },
  {
    path: '/our-company',
    component: () => import(/* webpackChunkName: "pages/views/company" */ 'views/Company'),
    meta: { i18nTitleKey: 'ourCompany' },
    name: 'our-company',
    beforeEnter(to, from, next) {
      const locale = i18n().locale;
      Promise.all([
        store.dispatch(`website/${GET_WEBSITE_OUR_COMPANY_PAGE_DATA}`, locale),
        store.dispatch(`website/${GET_EMPLOYEES_DATA}`, locale),
        store.dispatch(`website/${GET_REVIEWS_DATA}`, locale)
      ])
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_WEBSITE_OUR_COMPANY_PAGE_DATA);
        });
    }
  },
  {
    path: '/legal/:type',
    component: () => import(/* webpackChunkName: "pages/views/error" */ 'views/Legal'),
    name: 'legal',
    meta: { i18nTitleKey: 'legal' },
    beforeEnter: (to, from, next) => {
      store
        .dispatch(`website/${GET_WEBSITE_LEGAL_DATA}`, i18n().locale)
        .then(() => next())
        .catch(() => {
          redirectToErrorPage(next, GET_WEBSITE_LEGAL_DATA);
        });
    }
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error/500'),
    meta: { i18nTitleKey: 'error' }
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error/404'),
    meta: { i18nTitleKey: 'notFound' }
  }
];
